
<div>
  <template v-if="advancedFilterNotConfigured">
    <button v-if="parentErrorText" class="grey btn-link py-2" disabled>
      <icon class="filter-full"></icon>
      Advanced filter ({{parentErrorText}})
    </button>

    <button v-else type="button" class="btn-link blue py-2" @click="showAdvancedFilterBuilder">
      <icon class="filter-full"></icon>
      Advanced filter
    </button>
  </template>

  <template v-else-if="parentErrorText">
    <label>Advanced filter</label>
    <p class="error-text m-0 font-weight-normal">{{ parentErrorText }}</p>
  </template>

  <template v-else>
    <hr v-if="showSectionDivider">
    <row>
      <label for="show-advanced-filter" class="mr-auto">Advanced filter</label>

      <button type="button" class="btn-link blue px-2" @click="editAdvancedFilter">
        <icon class="pencil"></icon>
        Edit filter
      </button>

      <button type="button" class="btn-link blue px-2" @click="removeAdvancedFilter">
        <icon class="trash"></icon>
        Remove filter
      </button>
    </row>

    <template v-if="validationErrorMessage">
      <p class="error-text font-weight-normal">{{ validationErrorMessage }}</p>
    </template>
    <row v-else>
      <label for="toggle-advanced-filter" class="sr-only">On/Off Toggle</label>
      <div>
        <input v-model="advancedFilter.enabled" id="toggle-advanced-filter" type="checkbox" class="toggle-btn">
      </div>

      <p name="advanced-filter-show">
        Only show items if <span v-html="advancedFilterRuleSet.toHtmlString()"></span>
      </p>
    </row>
  </template>

  <single-set-conditional-display-modal
      v-if="advancedFilterRuleSet"
      :state="modalStateFor(vueModalID.conditionalDisplay)"
      :index="vueModalID.conditionalDisplay"
      :key="advancedFilterRuleSet.client_id"
      :parent="advancedFilter"
      :rule-set="advancedFilterRuleSet"
      :conditional-rule-options="conditionalRuleOptions"
      hide-preview
      v-bind="conditionalDisplayModalTexts"
      @toggle-modal="hideModal(vueModalID.conditionalDisplay)"
  ></single-set-conditional-display-modal>
</div>
